import React, { useState, useContext } from "react";
import styled from "styled-components";

import colors from "styles/colors";
import media from "styles/media";
import text from "styles/text";

import HybridBanner from "components/HybridBanner";
import { CursorContext, ScreenContext } from "components/Providers";

import DiscordSVG from "assets/images/icons/discord.svg";
import TwitterSVG from "assets/images/icons/twitter.svg";
import InstagramSVG from "assets/images/icons/instagram.svg";
import MediumSVG from "assets/images/icons/medium.svg";

import links from 'utils/links';

const MultiBanner: React.FC = () => {
  const [twitterLoaded, setTwitterLoaded] = useState(false);
  const [mediumLoaded, setMediumLoaded] = useState(false);
  const [instagramLoaded, setInstagramLoaded] = useState(false);
  const [discordLoaded, setDiscordLoaded] = useState(false);

  const cursor = useContext(CursorContext);
  const screen = useContext(ScreenContext);

  const cursorEnter = () => {
    if (screen.mobile || screen.tablet) {
      cursor.setValue({ roadmap: false, banners: false })
    } else {
      cursor.setValue({ roadmap: false, banners: true })
    }
  }

  return (
    <Wrapper  onMouseEnter={cursorEnter} onMouseLeave={() => cursor.setValue({ roadmap: false, banners: false })} id="Multi__Banner">
      <SocialKicker>&gt;&gt; Check us out on social 👇</SocialKicker>

      <GradientBG>
        <HybridBanner link={links.discord} animationClass={".Discord__Banner-Child"} loaded={discordLoaded} background={colors.horzGradient} left={true}>
          <Inner className="Discord__Banner-Child">
            <Text>Discord</Text> <Social src={DiscordSVG} alt="discord" onLoad={() => setDiscordLoaded(true)} />
          </Inner>
        </HybridBanner>

        <HybridBanner link={links.twitter} animationClass={".Twitter__Banner-Child"} loaded={twitterLoaded} background={colors.horzReverseGradient} left={false}>
          <Inner className="Twitter__Banner-Child">
            <Text>Twitter</Text> <Social src={TwitterSVG} alt="twitter" onLoad={() => setTwitterLoaded(true)} />
          </Inner>
          
        </HybridBanner>

        <HybridBanner link={links.instagram} animationClass={".Instagram__Banner-Child"} loaded={instagramLoaded} background={colors.horzGradient} left={true}>
          <Inner className="Instagram__Banner-Child">
            <Text>Instagram</Text> <Social src={InstagramSVG} alt="instagram" onLoad={() => setInstagramLoaded(true)} />
          </Inner>
          
        </HybridBanner>

        <HybridBanner link={links.medium} animationClass={".Medium__Banner-Child"} loaded={mediumLoaded} background={colors.horzReverseGradient} left={false}>
          <Inner className="Medium__Banner-Child">
            <Text>Medium</Text> <Social src={MediumSVG} alt="medium" onLoad={() => setMediumLoaded(true)} />
          </Inner>
        </HybridBanner>
      </GradientBG>
      
    </Wrapper>
  );
};

export default MultiBanner;

const Wrapper = styled.div`
  width: 100%;
  height: 16.39vw;
  cursor: none;
  ${media.tablet} {
    height: 30.031vw;
  }
  ${media.mobile} {
    height: 84.8vw;
  }
  ${media.mobile} {
    height: 74.667vw;
  }
`;

const SocialKicker = styled.div`
    display: none;
    
  ${media.tablet} {
    ${text.tablet.accent2};
    color: ${colors.pureWhite};
    display: block;
    position: absolute;
    text-transform: uppercase;
    width: 27.977vw;
    height: 1.758vw;
    left: 5.957vw;
  }
  ${media.mobile} {
    ${text.mobile.accent2}
    color: ${colors.pureWhite};
    display: block;
    position: absolute;
    width: 100%;
    height: 4.8vw;
    left: 4vw;
  }
`

const GradientBG = styled.div`
  ${media.tablet} {
    background: linear-gradient(180deg, #eeb93c 0%, #ff148199 100%);
    position: relative;
    width: 100%;
    height: 19.65vw;
    z-index: 11;
    top: 5.664vw;
  }
`

const Social = styled.img`
  width: auto;
  height: 1.74vw;
  cursor: pointer;
  margin: 0 1.04vw;
  filter: grayscale(1) brightness(0);
  ${media.tablet} {
    height: 2.441vw;
    margin: -0.488vw 1.465vw;
  }
  ${media.mobile} {
    height: 6.667vw;
    margin: -2.933vw 2.667vw;
  }
`;

const Text = styled.div`
  height: 1.74vw;
  line-height: 1.74vw;
`;

const Inner = styled.div`
  display: flex;
  position: relative;
`;